(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-dashhudson"] && !Shopify.designMode) return;
  try {
    
  const widgetElement = document.getElementById('dashhudson-widget');

  // Whatever is put inside the callback will be called whenever there is a mutation on the "widgetElement"
  const observer = new MutationObserver(
    (_mutationList, _observer) => {
      // When no images are returned, there is an element with the class ".empty"
      const emptyWrapper =
        widgetElement.getElementsByClassName('empty');
      if (emptyWrapper.length > 0) {
        widgetElement.style.visibility = 'hidden';
      } else {
        widgetElement.style.visibility = 'visible';
      }
    }
  );

  const config = {
    attributes: false,
    characterData: false,
    childList: true,
    subtree: true,
    attributeOldValue: false,
    characterDataOldValue: false,
  };
  observer.observe(widgetElement, config);

  } catch(e) { console.error(e); }
})();
})();
